// 本文件包括comfy页面加载后出现的modal框
import React, { useEffect, useState } from 'react';
import { setTempState, setProjectState, useTempState } from '@starflow/app/store';
import { Modal } from 'antd';
import { request } from '@shakkerai/services';
import styles from './referer.module.scss';
import { translate } from '@shakkerai/util-i18n';
import { Icon } from '@shakkerai/components';
import { convert2CompressedUrl } from '@shakkerai/util-image';
import cs from 'classnames';
import { enterWorkflowMode } from '../helpers/helpers';

export const WorkflowReferer = React.memo(() => {
  const [model, setModel] = useState();
  const [loading, setLoading] = useState(false);
  const currentWorkflowId = useTempState('currentWorkflowId');
  useEffect(() => {
    (async () => {
      const workflow = new URLSearchParams(window.location.search).get('workflow');
      if (workflow) {
        setProjectState({
          currentElementTool: 'workflow',
          currentNodeId: null,
        });
        setTempState({
          currentWorkflowId: workflow,
        });
        setLoading(true);
        try {
          const result = await request(`/api/www/img/tool/style/model/baseDetail/${workflow}`);
          if (result.code === 0) {
            setModel(result.data);
          }
        } catch (err) {
          console.log('api error', err);
        } finally {
          setLoading(false);
        }
      }
    })();
  }, []);
  const jumpToWorkFlow = () => {
    closeModel();
    enterWorkflowMode(model);
  };
  const closeModel = () => {
    setTempState({ currentWorkflowId: '' });
    const url = new URL(window.location.href);
    url.searchParams.delete('workflow');
    window.history.pushState({}, 0, url);
  };
  if (!model) return null;
  const { name, userAvatar, userName, images } = model;
  const Content = () => {
    return (
      <div className="relative">
        <Icon
          onClick={() => closeModel()}
          fontSize={16}
          className="shk-prompt-lora-guanbi text-[#828282] cursor-pointer absolute right-[-10px] top-[-6px] hover:text-[#000]"
        />
        <div className="flex">
          <div
            className="size-[118px] overflow-hidden bg-contain flex-shrink-0 rounded"
            style={{ backgroundImage: `url(${convert2CompressedUrl(images[0]?.imageUrl, 118)})` }}
          ></div>
          <div className="ml-3 flex flex-col">
            <div className={cs('text-[#2d2d2d] font-semibold text-sm mt-1 mb-4', styles.title)}>{name}</div>
            <div className="flex items-center mb-4">
              <div
                className="size-[24px] overflow-hidden bg-contain flex-shrink-0 rounded-full"
                style={{ backgroundImage: `url(${convert2CompressedUrl(userAvatar)})` }}
              ></div>
              <div className={cs('ml-2', styles.name)}>{userName}</div>
            </div>
          </div>
        </div>
        <button
          onClick={(e) => jumpToWorkFlow(e)}
          className="bg-[#2c2c2c] rounded-[2px] w-full mt-4 py-2 text-white text-[13px] font-medium"
        >
          {translate('use_btn')}
        </button>
      </div>
    );
  };
  return currentWorkflowId ? (
    <Modal
      centered
      open={true}
      classNames={{
        content: styles.content,
        body: styles.body,
        mask: styles.mask,
      }}
      onClose={() => {
        closeModel();
      }}
      width={376}
      closable={false}
      footer={null}
    >
      {loading ? (
        <div className="flex items-center justify-center my-16 text-xs text-[#7f7f7f]">{translate('loading')}...</div>
      ) : (
        <Content />
      )}
    </Modal>
  ) : null;
});
